// Короткий чайм уведомления — синтез через WebAudio, без бинарных ассетов.
// Fail-soft: нет AudioContext / автоплей заблокирован до жеста — молча no-op
// (в звонке жест уже был: пользователь кликал «войти»).

let ctx: AudioContext | null = null

function audioContext(): AudioContext | null {
  if (typeof AudioContext === 'undefined') return null
  ctx ??= new AudioContext()
  if (ctx.state === 'suspended') void ctx.resume().catch(() => {})
  return ctx
}

export function playNotifySound(): void {
  try {
    const ac = audioContext()
    if (ac?.state !== 'running') return
    const now = ac.currentTime
    // Два мягких синусоидных тона (E6 → A6) с быстрым затуханием.
    for (const [offset, freq] of [
      [0, 1318.5],
      [0.09, 1760],
    ] as const) {
      const osc = ac.createOscillator()
      const gain = ac.createGain()
      osc.type = 'sine'
      osc.frequency.value = freq
      gain.gain.setValueAtTime(0.0001, now + offset)
      gain.gain.exponentialRampToValueAtTime(0.06, now + offset + 0.02)
      gain.gain.exponentialRampToValueAtTime(0.0001, now + offset + 0.35)
      osc.connect(gain).connect(ac.destination)
      osc.start(now + offset)
      osc.stop(now + offset + 0.4)
    }
  } catch {
    // Звук — best-effort, ошибка не должна ломать уведомление.
  }
}
